import { ADMIRALTY_RELIABILITY_COLOR } from '@/types/walletIntel';
import type { AdmiraltyGrade } from '@/types/walletIntel';

interface Props {
  grade: AdmiraltyGrade;
  compact?: boolean;
}

// "A1"-style Admiralty-Code badge: Source Reliability (A-F) + Information
// Credibility (1-6). Hover shows the rationale behind the grade.
export function AdmiraltyBadge({ grade, compact = false }: Props) {
  const c = ADMIRALTY_RELIABILITY_COLOR[grade.source_reliability];
  return (
    <span
      title={grade.rationale}
      className="inline-flex items-center gap-1 rounded-md font-mono font-bold cursor-help"
      style={{
        background: `${c}18`,
        color: c,
        border: `1px solid ${c}30`,
        padding: compact ? '3px 7px' : '4px 9px',
        fontSize: compact ? 11 : 12,
      }}
    >
      {grade.source_reliability}{grade.information_credibility}
    </span>
  );
}
